module.exports = __webpack_public_path__ + "static/img/0545_7.6f11b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_7.jpg
// module id = CPP9
// module chunks = 1